/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
  Box,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";
import styled from "@emotion/styled";
import RetrunFindCoupon from './ReturnFindCoupon';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Container = styled(Box)`
  padding: 10px;
`;

const CouponContainer = styled(Box)`
  display: flex;
  margin-top: 10px;
  align-items: center;
`;

// 등록하기 팝업
function ReturnAdd(props) {
  const { openAdd, setOpenAdd, login, load_data } = props;
  const token = localStorage.getItem("token");
  const [mb_name, setMbName] = useState('');
  const [openFindCoupon, setOpenFindCoupon] = useState(false); // 쿠폰찾기 팝업
  const [coupon, setCoupon] = useState({
    seq: 0,
    name: '',
    mcd:'',
  });
  const title = '쿠폰반환';
  const [reason, setReason] = useState('');
  const [reason_etc, setReasonEtc] = useState('');
  const [file , setFile] = useState(null);
  
  const onSubmit = async () => {
    
    const formData = new FormData();
    if(file === null) {
      Swal.fire('오류', '업로드할 이미지를 선택하세요.');
      return;
    }   

    formData.append('file', file);  
    formData.append('coupon_seq', coupon.seq);
    formData.append('mcd', coupon.mcd);
    formData.append('reason',reason);
    formData.append('reason_etc', reason_etc);
    let result = await axios.post(configState.api+'/gympass_admin/return_add', formData);
    
    setOpenAdd(false);
    load_data(); // 부모창 새로고침
  }

  const onImageChange = e => {
    setFile(e.target.files[0]);
  }

  useEffect(() => {
    if(openAdd) {
      setCoupon({
        seq:0,
        name:'',
        mcd:''
      })
    }
  }, [openAdd]);


  return <>

    {/* 쿠폰찾기팝업 */}
    <RetrunFindCoupon openFindCoupon={openFindCoupon}
      setOpenFindCoupon={setOpenFindCoupon}
      login={login}
      setCoupon={setCoupon}
    ></RetrunFindCoupon>

    <Dialog
      open={openAdd}
      fullWidth={true}
      maxWidth="sm"
      TransitionComponent={Transition}
      onClose={() => setOpenAdd(false)}
    >

      <AppBar sx={{ position: "static" }}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography style={{ fontSize: 18 }}>{title}내역 추가</Typography>
          </Box>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setOpenAdd(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 1, mt: 2 }}>
        <Box display="flex">
          <TextField
            InputProps={{
              readOnly: true,
            }}
            name="coupon_name"
            label="쿠폰명"
            size="small"
            sx={{
              width: "280px",
            }}
            autoComplete="off"
            value={coupon.name}
          ></TextField>
          <Box sx={{ ml: 1 }}>
            <Button
              variant="contained"
              onClick={() => {
                setOpenFindCoupon(true);
              }}
            >
              조회
            </Button>
          </Box>
        </Box>

        <Box sx={{mt:1}}>
          <FormControl sx={{ width: 240 }} size="small">
            <InputLabel>사유</InputLabel>
            <Select
              name="reason"
              label="사유"
              onChange={(e) => {
                setReason(e.target.value);
              }}
              value={reason}
            >              
              <MenuItem value="코로나">코로나 확진 (본인)</MenuItem>
              <MenuItem value="천재지변">천재지변 (화재, 침수)</MenuItem>
              <MenuItem value="사고및질병">사고 및 질병</MenuItem>
              <MenuItem value="부고">부고 (부모, 형제, 자매)</MenuItem>              
              <MenuItem value="기타">기타</MenuItem>          
            </Select>
          </FormControl>
        </Box>


        <Box sx={{mt: 1}}>
          <TextField
            name="reason_etc"
            label="기타 사유"
            size="small"
            sx={{
              width: "400px",
            }}
            autoComplete="off"
            value={reason_etc}
            onChange={(e) => setReasonEtc(e.target.value)}
          ></TextField>
        </Box>


        <Box sx={{mt: 1}}>
          <input accept='image/jpeg' type="file" onChange={onImageChange}/>          
        </Box>


        <Box
          sx={{
            mt: 5, textAlign: "center"
          }}
        >
          <Button variant="contained" onClick={() => onSubmit()}>
            등록완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={() => setOpenAdd(false)}
          >
            취소
          </Button>
        </Box>
      </Box>

    </Dialog >
  </>

}

export default ReturnAdd;